import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/home/Navbar';
import HeroSection from '../components/home/HeroSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import TimeTableSection from '../components/home/TimeTableSection';
import ReachPotentialSection from '../components/home/ReachPotentialSection';
import WhySudeshMathsSection from '../components/home/WhySudeshMathsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';
import Footer from '../components/home/Footer';
import FloatingAction from '../components/home/FloatingAction';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        // Optional: clean up state to prevent scroll on refresh if needed, 
        // though react-router state persists.
        // window.history.replaceState({}, document.title)
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <WhyChooseUs />
      <TimeTableSection />
      <ReachPotentialSection />
      <WhySudeshMathsSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
      <FloatingAction />
    </div>
  );
}
